import { ref, computed } from 'vue'
import { sortOptions } from '../../../shared/helpers/business/sort-map';

const sort = ref('')

function sortUpdate(value: string) {
  sort.value = value
}

const sortName = computed(() => {
  return sortOptions.find((i) => sort.value == i.id).title
})
export function useFilterSearchPage() {

  return {
    sort,
    sortName,
    sortUpdate
  }

}